import {netInfoSlice, NetInfoStateCustom} from './netInfo';
import {combineReducers} from 'redux';
import {blockingCallCountSlice, BlockingCallCountState} from './blockingCallCount';

export type HttpWrapperState = {
  blockingCallCount: BlockingCallCountState;
  netInfo: NetInfoStateCustom;
};

export const httpWrapper = combineReducers({
  blockingCallCount: blockingCallCountSlice.reducer,
  netInfo: netInfoSlice.reducer,
});
